// extracted by mini-css-extract-plugin
export default {"holder":"styles_holder__DbQKA","button":"styles_button__MbOgs","active":"styles_active__zJ3EE"};